export const removeDuplicatesByUuid = (array) => {
  if (!array) return null;
  const uniqueItemsMap = new Map();

  array.forEach((item) => {
    uniqueItemsMap.set(item.uuid, item);
  });

  return Array.from(uniqueItemsMap.values());
};
